import { createFileRoute } from '@tanstack/react-router'
import { FundamentalsIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/grundlagen/')({
  loader: () => loadPageData({ data: { kind: 'fundamentals', locale: 'de' } }),
  head: () => staticRouteHead('fundamentals', 'de'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <FundamentalsIndexPage />
    </CatalogProvider>
  )
}
